import React, { useCallback, useState } from "react";

import Select from "react-select";
import { DatePickerInput } from "../DatePickerInput";

import i18next from "i18next";

const AllChecklistReportForm = ({ groupingValues, onSubmit }) => {
    const [grouping, setGrouping] = useState(null);
    const [startAtDate, setStartAtDate] = useState(null);

    const doSubmit = useCallback((event) => {
        event.preventDefault();
        onSubmit({
            startAtDate: startAtDate,
            location: grouping,
        });
    }, [onSubmit, startAtDate, grouping]);

    return (
        <div className="op-content-box filter-box" style={{ marginBottom: 20 }}>
            <form onSubmit={doSubmit}>
                <ul className="list-inline clearfix">
                    <li className="pull-left box-label">
                        <h4 className="remove-margin-bottom">{i18next.t("filters")}</h4>
                    </li>
                </ul>

                <div className="row">
                    <div className="col-sm-3">
                        <label>{i18next.t("form-labels.location")}</label>
                        <Select
                            name={`location`}
                            options={groupingValues}
                            clearable={false}
                            searchable={true}
                            classNamePrefix="react-select"
                            onChange={(option) => { setGrouping(option.grouping);  }}
                            placeholder={i18next.t("form-labels.select-location")}
                        />
                    </div>

                    {grouping && (
                        <div>
                            <div className="align-date-picker pull-left">
                                <label>{i18next.t("form-labels.start-date")}</label>
                                <DatePickerInput 
                                    input={{ value: startAtDate }} 
                                    meta={{}} 
                                    onDayChange={setStartAtDate} 
                                    dayPickerProps={{
                                        disabledDays: {daysOfWeek: [1,2,3,4,5,6]}
                                    }}
                                />
                            </div>
                        </div>
                    )}

                    <div className="pull-left">
                        <label style={{ visibility: "hidden" }}>{i18next.t("form-labels.run-report")}</label>
                        <ul className="list-inline clearfix">
                            <li className="pull-left" style={{ marginLeft: "15px" }}>
                                <button type="submit" className="btn btn-sm btn-default pull-right" disabled={!(grouping && startAtDate)}>
                                    {i18next.t("form-labels.run-report")}
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default AllChecklistReportForm;
